import type { PostKidsEditRequest, PostKidsEditResponse } from '~/api/aspida/@types';
import { sendRequest } from '~/api/sendRequest';

export const postKidsEdit = sendRequest<PostKidsEditRequest, PostKidsEditResponse>({
  url: '/kids/edit',
  method: 'post',
});
